<template>
  <div @click="() => ((deleteArea = ''), (actionDialog = false))" class="no-tap">
    <!-- ヘッダー -->
    <div class="header-wrapper">
      <v-app-bar color="primary" flat>
        <v-btn style="position: absolute" icon="mdi-chevron-left" :to="'/'">
        </v-btn>
        <v-spacer></v-spacer>
          <v-toolbar-title v-if="child" style="min-width: fit-content;">
            {{ (child.lastName + ' ' + child.firstName).length > 11
                ? (child.lastName + ' ' + child.firstName).slice(0, 11) + '…' 
                : child.lastName + ' ' + child.firstName 
            }}
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          fab
          @click="openSelectChildDialog"
          :loading="btnLoadingChat"
          height="40"
          width="40"
        >
          <v-icon color="white">
            mdi-arrow-down-drop-circle-outline
          </v-icon>
        </v-btn>
        <template v-if="chatComment">
          <v-badge dot color="#E190CF" offset-x="8" offset-y="8">
            <v-app-bar-nav-icon @click="dialog = true"></v-app-bar-nav-icon>
          </v-badge>
        </template>
        <template v-else>
          <v-app-bar-nav-icon @click="dialog = true"></v-app-bar-nav-icon>
        </template>
      </v-app-bar>

      <!-- 日付選択・他画面遷移・コメント入力 -->
      <v-card rounded="0" v-if="isChatCreateUserMe">
        <div @click="openDateDialog">
          <DatePager
            :date="date"
            @addDay="addDay"
            @subtractDay="subtractDay"
            :isYear="false"
            :beforeTheDate="unReadCount ? unReadCount.beforeTheDate : 0"
            :afterTheDate="unReadCount ? unReadCount.afterTheDate : 0"
          />
        </div>
      </v-card>
      <v-divider></v-divider>
    </div>

    <!-- {{ $t('communication.chatList') }} -->
    <div v-if="!fetchLoading">
      <div class="chat-area" @scroll="tap()" @click="handleLinkClick">
        <div v-for="(chat, index) in chatPast" :key="index" class="d-flex flex-column ">
          <template v-if="chat.from" class="tap-on">
            <div class="d-flex">
            
              <template v-if="chat.bodyType === 'absence' || chat.bodyType === 'pickup'">
                <div class="info-wrapper parents-chat pa-2 ma-2" style="white-space:pre-line;" v-html="escapeAndLinkify(translatedChats[chat.chatId] ?? chat.body)"></div>
              </template>
              <template v-else>
                <div class="chat-wrapper pa-2 ma-2 tap-on">
                  <p style="white-space:pre-line; color: primary;" v-html="escapeAndLinkify(translatedChats[chat.chatId] ?? chat.body)"></p>
                </div>
              </template>
              

              <div class="d-flex flex-column align-self-end pb-2">
                <div v-if="!translatedChats[chat.chatId] && chat.bodyType === 'message'">
                  <v-btn style="height: 18px; color: #000000; border-color: #000000; border-width: 1px"
                    @click="openTranslateDialog(chat)">
                    <v-icon size="small">mdi-google-translate</v-icon>
                  </v-btn>
                </div>
                <div v-if="translatedChats[chat.chatId] && chat.bodyType === 'message'">
                  <v-btn style="height: 16px; color: #000000; border-color: #000000; border-width: 1px"
                    @click="returnTranslate(chat.chatId)">
                    <v-icon size="small">mdi-arrow-u-left-top</v-icon>
                  </v-btn>
                </div>
                <div class="grey--text text-caption">
                  {{ formatTime(chat.deliveredAt || chat.createdAt) }}
                </div>
              </div>
            </div>
            <template v-if="!chat.readAt">
              <v-chip
                label
                color="error"
                variant="outlined"
                class="pa-3 ml-2 mb-4"
                style="width: 40%; z-index: 0;"
                :disabled="btnLoadingChat"
                @click="dblClick(chat)"
              >
                <v-icon left>mdi-check</v-icon>{{ $t('communication.confirm') }}
              </v-chip>
            </template>
            <template v-if="chat.readAt">
              <v-chip
                label
                color=""
                variant="outlined"
                class="pa-2 ml-2 mb-4"
                style="width: 40%; z-index: 0;"
              >
                {{ $t('communication.confirmed') }}
              </v-chip>
            </template>
          </template>
          <template v-if="!chat.from">
            <div class="d-flex justify-end align-center reative">
              <div class="grey--text text-caption align-self-end pb-2">
                <div class="d-flex flex-column">
                  <div v-if="chat.readAt">{{ $t('communication.read') }}</div>
                  <div class="align-self-end">{{ formatTime(chat.deliveredAt || chat.createdAt) }}</div>
                </div>
              </div>
              <div
                class="chat-wrapper staff-chat pa-2 ma-2 group-chat no-tap"
                v-if="chat.bodyType === 'groupChat'"
                style="user-select: none;"
              >
                <div
                >
                  <p style="white-space:pre-line;">
                    {{ $t('communication.contactEmail') + '\n' }}
                    <!-- {{ chat.body }} -->
                  </p>
                  <!--
                  <v-runtime-template
                    :template="autoLink(chat.body)"
                  ></v-runtime-template>
                  -->
                  <div v-html="escapeAndLinkify(chat.body)"></div>
                </div>
                <div v-show="chat.attachmentUrls.length">
                  <!-- <v-btn
                    color="primary"
                    dark
                    text
                    small
                    @click="openChatImg(chat)"
                    :loading="imgLoading"
                  >
                    添付ファイルを表示する
                  </v-btn> -->
                  <div
                    v-for="(au, index) in chat.attachmentUrls"
                    :key="au.objectKey">
                    <v-card
                      v-if="!isPdf(au.objectKey)"
                      @click="openChatImg(chat, index)"
                      class="pointer mt-1"
                      style="min-width: 64vw;"
                      elevation="0">
                      <v-img :src="au.url" contain></v-img>
                    </v-card>
                    <v-btn
                      class="my-3"
                      v-else
                      color="primary"
                      dark
                      variant="text"
                      size="small"
                      @click="openChatImg(chat, index)"
                      :loading="imgLoading">
                      {{ $t('communication.showAttachment') }}
                    </v-btn>
                  </div>
                </div>
              </div>
              <div
                oncontextmenu="return false;"
                class="chat-wrapper staff-chat pa-2 ma-2 no-tap"
                style="white-space: pre-line;user-select: none;"
                v-else
              >
                <template v-if="isLink(chat.body)">
                  <div
                    v-html="escapeAndLinkify(chat.body)"
                    class="autolinked"
                  ></div>
                </template>
                <template v-else>
                  <p class="autolinked" style="pointer-events: none;">{{ chat.body }}</p>
                </template>
              </div>
              <v-btn
                icon
                variant="plain"
                @click="handleContentClick(chat, $event)"
                small
              >
                <v-icon>mdi-dots-vertical-circle-outline</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </div>

      <!-- {{ $t('communication.send') }}/{{ $t('communication.draft') }} -->
      <div class="input-wrapper pa-1">
        <v-divider class="mb-2"></v-divider>
        <div v-if="!isChatCreateUserMe" class="primary--text font-weight-bold">{{ $t('communication.viewOnly') }}</div>
          <v-textarea
            variant="outlined"
            v-model="inputText"
            auto-grow
            rows="1"
            row-height="15"
            hide-details
            density="compact"
            class="input-chat-area pa-0"
            color="primary"
          ></v-textarea>
          <MessageHandle
            @saveDraft="saveDraft"
            @saveSendReady="saveSendReady"
            @sendMessage="sendMessage"
            :btnSendLoading="btnSendLoading"
            :btnDraftLoading="btnDraftLoading"
            :btnReadyLoading="btnReadyLoading"
            :inputText="inputText"
            :isChatCreateUserMe="isChatCreateUserMe"
          />
      </div>
    </div>
    <div v-else>
      <VueLoading :height="'50vh'" />
    </div>

    <v-dialog
      v-model="dialogSelectChild"
      width="280px"
      scrollable
    >
      <v-card class="selectItemList pb-0">
        <v-card-title>
          <v-select
            v-model="selectedClass"
            :items="classList"
            item-title="className"
            item-value="classId"
            @update:model-value="selectChildItems"
            variant="filled"
            hide-details
            return-object
            color="rgb(105,105,105)"
          >
          </v-select>
        </v-card-title>

        <v-card-text style="height: 40vh" class="childList">
          <v-list>
            <v-list-item
              v-for="(c,index) in childList"
              :key="index"
              @click="toClassChildren(c)"
            >
              <v-list-item-content> {{ c.name }} </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" class="comment-dialog">
      <v-card>
        <v-card-title class="headline lighten-2"> </v-card-title>

        <div class="d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--outlined">
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="outlined"
            @click="onClickAbsencedeleteDialog()"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('communication.absenceConfirmDelete') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="outlined"
            @click="openAbsenceRegistDialog"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('absence.title') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <div class="d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--flat">
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="flat"
            @click="toChildDiary"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('navigation.toTodayRecord') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="flat"
            :to="`/communication/ready-send-box`"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('communication.goToReadySendBox') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
        </div>
        <div class="d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--flat">
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="flat"
            :to="`/communication/draft`"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('communication.goToDraft') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
          <v-btn
            class="comment-dialog-quick-btn"
            :class="{ 'comment-dialog-quick-btn--ja': isJapaneseLocale }"
            color="primary"
            variant="flat"
            @click="clickToParentsRecord"
          >
            <span class="comment-dialog-quick-btn__inner">
              <span class="comment-dialog-quick-btn__label">{{ $t('navigation.toParentsRecord') }}</span>
              <v-icon class="comment-dialog-quick-btn__chevron" size="20">mdi-chevron-right</v-icon>
            </span>
          </v-btn>
        </div>

        <v-divider />

        <!-- <v-textarea
          solo
          flat
          hide-details
          auto-grow
          row-height="1"
          name="comment"
          :placeholder="$t('communication.enterComment')"
          prepend-inner-icon="mdi-note-outline"
          v-model="inputComment"
          clearable
          class="comment-area"
          style="white-space:pre-wrap;"
        ></v-textarea> -->
        <v-textarea
          variant="solo"
          flat
          hide-details
          rows="1"
          auto-grow
          name="comment"
          :placeholder="$t('comment.placeholder')"
          prepend-inner-icon="mdi-note-outline"
          v-model="inputComment"
          clearable
          class="comment-area"
          style="white-space:pre-wrap;"
          :maxlength="COMMENT_MAX_LENGTH"
          :counter="COMMENT_MAX_LENGTH"
          :rules="commentRules"
        ></v-textarea>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="saveComment" :loading="commentLoading">
            {{ $t('comment.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog">
      <v-card>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-title class="headline lighten-2">{{ $t('communication.deleteConfirm') }}</v-card-title>
        </div>
        <div v-if="tempChat.body" class="d-flex px-3">
          <v-card-subtitle
            style="white-space: pre-line; user-select: none;"
            class="d-flex justify-center"
            >{{ showLongText(tempChat.body) }}</v-card-subtitle
          >
        </div>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-actions>
            <v-btn @click="() => (deleteDialog = false)" variants="text">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              class="ml-5"
              variant="flat"
              @click="deleteChat()"
              :loading="deleteLoading"
            >
              {{ $t('common.delete') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="actionDialog">
      <v-card>
        <div class="d-flex flex-column">
          <v-btn v-if="chatType != 'groupChat'" @click="clickDeleteDialog(tempChat)">
            <span>{{ $t('common.delete') }}</span>
            <v-icon right>mdi-trash-can-outline</v-icon>
          </v-btn>
          <v-btn @click="onCopyTextCopy">
            <span>{{ $t('communication.copyText') }}</span>
            <v-icon right>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isTranslationDialog" persistent max-width="400px">
      <TranslationModal :isOpen="isTranslationDialog" :childId="childId" :selectedChat="translationChat"
        @translate="onTranslated" @close="isTranslationDialog = false" />
    </v-dialog>

    <v-dialog
      v-model="absenceRegistDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="absence-dialog"
    >
      <AbsenceModal
        :isOpen="absenceRegistDialog"
        :childId="childId"
        :date="date"
        :nurseryId="nurseryId"
        @close="absenceRegistDialog = false"
        @posted="createAbsence"
      />
    </v-dialog>

    <v-dialog
      v-model="absencedeleteDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="absence-dialog"
    >
      <AbsenceDeleteModal
        :chatsAbsence="chatsAbsence"
        :childId="childId"
        :date="date"
        :nurseryId="nurseryId"
        @close="absencedeleteDialog = false"
        @posted="deleteAbsence"
      />
    </v-dialog>

    <v-dialog
      class="pt-5"
      v-model="isAttachmentUrls"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="pdf_wrapper pt-5">
        <div class="pdf_header_wrapper">
          <v-toolbar class="pdf_header" dark color="primary">
            <v-btn icon dark @click="closeChatImg" absolute>
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer />
            <!-- <v-toolbar-title>{{ childName }}</v-toolbar-title> -->
            <v-spacer />
          </v-toolbar>
        </div>
        <div class="pdf">
          <div v-for="u in showingUrls" :key="u">
            <object v-if="u.indexOf('.pdf?') >= 0" :data="u" type="application/pdf" width="100%" height="100%">
              <iframe :src="u" width="100%" height="100%"></iframe>
              <div class="pdf-fallback">
                <p><b>{{ $t('communication.pdfFallback') }}</b>: <a :href="u">{{ $t('communication.downloadPdf') }}</a>.</p>
              </div>
            </object>
            <img v-else style="width: 100%;" :src="u" />
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dateDialogFlg"
      width="auto"
      max-width="100%"
    >
        <v-locale-provider :locale="$i18n.locale">
          <v-date-picker
            v-model="selectedDate"
            type="date"
            :day-format="(date) => new Date(date).getDate()"
            @update:model-value="dateSelected"
            no-title
            hide-header
            color="primary"
          >
          </v-date-picker>
        </v-locale-provider>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="ourline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import DatePager from '@/components/molecules/DatePager.vue';
import MessageHandle from '@/components/MessageHandle.vue';
import AbsenceModal from '@/components/molecules/AbsenceModal.vue';
import AbsenceDeleteModal from '@/components/molecules/AbsenceDeleteModal.vue';
import TranslationModal from '@/components/molecules/TranslationModal.vue';

import dayjs from 'dayjs';
import { formatChatTime } from '@/utils/dayjsTz';
import { childrenModule } from '@/store/dataModules/childrenModule';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import {
  ChatCommentResponse,
  ChatResponse,
  HomeChatResponse,
  GroupChatResponse,
  NurseryAttendanceResponse,
  NurseryChildResponse,
  NurseryClassResponse,
} from 'chaild-api/lib';
import VueLoading from '@/components/pages/Loding.vue';
import { chatModule } from '@/store/dataModules/chatModule';
import LocalDataService from '@/service/LocalDataService';
import { GetChildrenResponse } from '@/model/Response';
import { Members } from 'pusher-js';
import { meModule } from '@/store/dataModules/meModule';
import VRuntimeTemplate from 'v-runtime-template';
import { getBusinessYearForJapanTz, getDayjsInstanceTz} from 'chaild-api/src/common/moment/momentUtils';
import { i18n } from '@/plugins/i18n';
import { escapeAndLinkify } from '@/utils/sanitize';
// new Vue({
//   el: '#app',
//   methods: {
//     dblClick() {
//       alert("double click")
//     }
//   }
// })

export default defineComponent({
  directives: {},
  components: {
    VRuntimeTemplate,
    DatePager,
    MessageHandle,
    VueLoading,
    AbsenceModal,
    AbsenceDeleteModal,
    TranslationModal,
  },
  data: () => {
    return {
      year: dayjs().year(),
      month: dayjs().month(),
      date: dayjs(),
      nurseryId: 0,
      dialogSelectChild: false,
      selectedClass: '' as any,
      childList: [] as any,
      classList: [] as any,
      loadFlg: false,
      dialog: false,
      inputText: '',
      childId: 0 as number,
      classId: 0,
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      fetchLoading: false,
      btnSendLoading: false,
      btnDraftLoading: false,
      btnReadyLoading: false,
      btnLoadingChat: false,
      imgLoading: false,
      commentLoading: false,
      clickCount: 0,
      btnChatId: NaN,
      inputComment: '',
      COMMENT_MAX_LENGTH: 500,
      draftChatId: '',
      readyChatId: '',
      offset: true,
      actionDialog: false,
      deleteDialog: false,
      deleteLoading: false,
      absenceRegistDialog: false,
      absencedeleteDialog: false,
      tempChat: {} as ChatResponse,
      isAttachmentUrls: false,
      showingUrls: [] as Array<{ url: string; objectKey: string; }>,
      counter: 0,
      firstScroll: 0,
      currentScroll: 0,
      isLongTapAble: true,
      setTime: null as any,
      isImgDialog: false,
      notPdfImgSrc: '',
      chatType: '',
      dateDialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
      windowHistory: '' as any,
      isTranslationDialog: false,
      translationChat: null as ChatResponse | null,
      translatedChats: {} as Record<number, string>,
    };
  },
  computed: {
    clas(): NurseryClassResponse | null {
      if (nurseryModule.clas) {
        this.selectedClass = nurseryModule.clas;
        return nurseryModule.clas;
      }
      return null;
    },
    child(): NurseryChildResponse | null {
      if (childrenModule.child) {
        return childrenModule.child;
      }
      return null;
    },
    unReadCount(): any {
      if (chatModule.chats) {
        return chatModule.chats.unReadCount;
      }
      return null;
    },
    chatPast(): ChatResponse[] | null {
      if (chatModule.chats) {
        const chats = chatModule.chats.chats;
        const result = chats.filter(chat => {
          return chat.child.childId === this.childId;
        });
        return result;
      }
      return null;
    },
    chatComment(): ChatCommentResponse | null {
      if (chatModule.chats) {
        return chatModule.chats.comment;
      }
      return null;
    },
    commentRules(): ((v: string) => boolean | string)[] {
      const t = (this as any).$t;
      return [
        (v: string) => !v || v.length <= this.COMMENT_MAX_LENGTH || t('comment.exceedsLimit'),
      ];
    },
    isJapaneseLocale(): boolean {
      const locale = i18n.global.locale.value.toString().toLowerCase();
      return locale === 'ja' || locale.startsWith('ja-');
    },
    chatsDraft(): ChatResponse[] {
      const chatsDraft = chatModule.chatsDraft;
      if (chatsDraft) {
        chatsDraft.sort(function(a, b) {
          if (a.date > b.date) {
            return -1;
          } else {
            return 1;
          }
        });
        return chatsDraft;
      }
      return [];
    },
    chatDetail(): ChatResponse | null {
      if (this.draftChatId && this.chatsDraft.length > 0) {
        const find = this.chatsDraft.find(chat => chat.chatId === Number(this.draftChatId));
        if (find) {
          return find;
        }
      }

      return null;
    },
    isChatCreateUserMe(): boolean {
      const queryUserId = this.$route.query.userId as string;
      const user = LocalDataService.getUser();
      if (queryUserId && user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const myUserId = nurserySchool.userId.toString();
        if (myUserId === queryUserId) {
          return true;
        }
        return false;
      }
      return true;
    },
    chatsAbsence(): NurseryAttendanceResponse[] {
      const chatsAbsence = chatModule.chatsAbsence;
      if (chatsAbsence) {
        // すでにレスポンスがソート済なため
        // chatsAbsence.sort(function(a, b) {
        //   if (a.startedAt > b.startedAt) {
        //     return -1;
        //   } else {
        //     return 1;
        //   }
        // });
        return chatsAbsence;
      }
      return [];
    },
  },
  watch: {
    date: {
      handler() {
        this.init();
        this.selectClassItems();
      },
      deep: true,
    },
    chatPast: {
      handler: async function() {
        setTimeout(this.chatsScrollToBottom, 500);
      },
      deep: true,
    },
  },
  methods: {
    escapeAndLinkify,
    handleLinkClick(event: Event) {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest?.('a') as HTMLAnchorElement | null;
      if (anchor?.href) {
        event.preventDefault();
        event.stopPropagation();
        this.urlClicked(anchor.href);
      }
    },
    async toClassChildren(child: NurseryChildResponse) {
      if (this.windowHistory === '') {
        this.windowHistory = this.$route.params.classId;
      }

      //現在開いている園児以外を選択した時のみ this.$router.push を行う
      const childId = `${child?.childId}`;
      if (this.$route.params.childId != childId) {
        await this.$router.push({
          path: `/communication/chat/${childId}?date=${this.date.format('YYYY-MM-DD')}`,
          query: { date: `${this.date.toISOString()}` }
        });
      }

      this.init();
      this.dialogSelectChild = false;
    },
    //クラス情報取得（開いている個人日誌の日付を元に取得）
    async selectClassItems() {
      this.classList = [];
      this.month = dayjs(this.date).month();
      this.year = dayjs(this.date).year();
      if (this.month < 7) {
        this.year = this.year - 1;
      }
      if (this.nurseryId && this.year) {
        const classList = nurseryModule.getNurseryClassWithYear({
          nurseryId: this.nurseryId,
          year: this.year
        })
        this.classList = (await classList);
      }
      if (this.classList.length === 0) {
        this.classList.push({
          classId: 0,
          className: i18n.global.t('communication.noClassAssigned'),
        });
      }
    },
    //選択されているクラスに登録されている園児情報取得
    async selectChildItems() {
      this.childList = [];
      this.loadFlg = true;
      const date = this.date.format('YYYY-MM-DD');
      if (this.selectedClass.year == getBusinessYearForJapanTz(getDayjsInstanceTz(date))) {
        const listData =  childrenModule.getChildren({
          nurseryId:this.nurseryId,
          classId: this.selectedClass.classId,
        });

        const arr = (await listData).children;
        const len = arr.length;
        const baseDay = getDayjsInstanceTz(this.date);
        for (let i = 0; i < len; i++) {
          if ((arr[i].graduationDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].graduationDate!))) // 卒園済
            || (arr[i].quitDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].quitDate!))) // 退園・転園済
            || (arr[i].admissionDate && getDayjsInstanceTz(arr[i].admissionDate).isAfter(baseDay)) // 入園前
          ) {
            continue;
          }
          this.childList.push({
            childId: arr[i].childId,
            name: arr[i].lastName + arr[i].firstName,
          })
        }
        this.loadFlg = false;
        return this.childList;
      } else {
        this.loadFlg = false;
      }
    },
    openSelectChildDialog() {
      if (this.child) {
        this.dialogSelectChild = true;
        this.selectedClass = this.clas;
        this.selectChildItems();
      }
    },
    handleContentClick(chat: ChatResponse, event) {
      this.chatType = chat.bodyType;
      this.setTime = setTimeout(() => this.activeModal(chat), 0);
      // クリックされた要素が <a> タグであり、href 属性を持っているかを確認
      if (event.target.tagName === 'A' && event.target.href) {
        const url = event.target.href;
        console.log('handleContentClick: Link clicked!', url); // このログが出ればOK
      
        // urlClicked 関数を呼び出す
        this.urlClicked(url);

        // <a> タグのデフォルトのリンク遷移を停止し、
        // urlClicked 関数内で遷移を制御できるようにします。
        event.preventDefault(); 
      }
    },
    changeValue(amount) {
      this.counter = this.counter + amount;
    },
    resetValue() {
      this.counter = 0;
    },
    activeModal(chat: ChatResponse) {
      if (this.firstScroll === this.currentScroll) {
        this.actionDialog = true;
        this.tempChat = chat;
      } else {
        console.log('first', this.firstScroll);
        console.log('current', this.currentScroll);
        this.currentScroll = this.firstScroll;
      }
      console.log('first', this.firstScroll);
      console.log('current', this.currentScroll);
    },
    isLink(text: string) {
      const urlArr = text.match(/(https?:\/\/[^\s]*)/g);
      if (urlArr && urlArr.length) {
        return true;
      }
      return false;
    },
    urlClicked(url: string) {
      console.log('urlClicked', url);
      const ua = navigator.userAgent;
      const isIOS =
        ua.indexOf('iPhone') >= 0 ||
        ua.indexOf('iPad') >= 0 ||
        Number(navigator.userAgent.indexOf('iPod')) >= 0;
      // webkit オブジェクトと messageHandlers が存在し、かつ openUrl ハンドラも存在するかをチェック
      if (isIOS && (window as any).webkit && (window as any).webkit.messageHandlers && (window as any).webkit.messageHandlers.openUrl) {
         console.log('WebView (iOS) environment detected. Calling webkit.messageHandlers.openUrl');
         (window as any).webkit.messageHandlers.openUrl.postMessage(url);
      } else {
         // Android、またはiOSの通常ブラウザ（Safariなど）の場合
         console.log('Standard browser or Android environment. Opening URL with window.open');
         window.open(url);
      }
    },
    async onClickAbsencedeleteDialog() {
      this.dialog = false;
      await this.$nextTick();
      this.absencedeleteDialog = true;
      await chatModule.getChatsAbsence(this.childId);
    },
    openAbsenceRegistDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.absenceRegistDialog = true;
      });
    },
    tap() {
      const selectedElement: Element = document.getElementsByClassName('chat-area')[0];
      this.currentScroll = selectedElement.scrollTop;
      if (this.counter === 0) {
        this.firstScroll = selectedElement.scrollTop;
      } else {
        this.counter = 0;
      }
      console.log('scroll', this.firstScroll, this.currentScroll);
    },
    showLongText(body: string) {
      let replace = body.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
      const length = replace.length;
      if (length > 150) {
        replace = replace.slice(0, 150) + '...';
        return replace;
      }
      return body;
    },
    onCopyTextCopy() {
      console.log(this.tempChat);
      navigator.clipboard.writeText(this.tempChat.body).catch(e => {
        console.error(e);
      });
      this.actionDialog = false;
      this.snackBarText = i18n.global.t('communication.copied');
      this.snackbar = true;
    },
    onCopyTextError() {
      this.actionDialog = false;
      this.snackBarText = i18n.global.t('communication.copyFailed');
      this.snackbar = true;
    },
    insertStr(str, index, insert) {
      return str.slice(0, index) + insert + str.slice(index, str.length);
    },
    formatAmzIso(dateStr: string): string {
      let formatted = dateStr;
      formatted = this.insertStr(formatted, 4, '-');
      formatted = this.insertStr(formatted, 7, '-');
      formatted = this.insertStr(formatted, 13, ':');
      formatted = this.insertStr(formatted, 16, ':');
      return formatted;
    },
    isPresignedUrlExpired(url: string): boolean {
      try {
        const expiresFromIndex = url.indexOf('?Expires=') + 9;
        const expiresEndIndex = url.indexOf('&Key-Pair-Id=');
        const expires = Number(url.substring(expiresFromIndex, expiresEndIndex));
        if (expires) {
          const Now = dayjs();
          const isExpired = Now.isAfter(dayjs.unix(expires));
          return isExpired;
        } else {
          return true;
        }
      } catch (error) {
        return true;
      }
    },
    isPdf(objectKey: string) {
      const arr = objectKey.split('.');
      const ext = arr[arr.length - 1];
      if (ext === 'pdf') {
        return true;
      }
      return false;
    },
    async openChatImg(chat: ChatResponse, index: number) {
      let img = chat.attachmentUrls[index].url;
      const isPdf = this.isPdf(chat.attachmentUrls[index].objectKey);
      if (isPdf) {
        // const isImgExpired = this.isPresignedUrlExpired(
        //   chat.attachmentUrls[index].url,
        // );
        // if (isImgExpired) {
        //   this.imgLoading = true;
        //   const objectKey = chat.attachmentUrls[index].objectKey;
        //   const imgContent = await resourceModule.postResourceDownload({
        //     objectKey,
        //   });
        //   img = imgContent.preSignedUrl;
        //   this.imgLoading = false;
        // }
        const ua = navigator.userAgent;
        const isIOS =
          ua.indexOf('iPhone') >= 0 ||
          ua.indexOf('iPad') >= 0 ||
          Number(navigator.userAgent.indexOf('iPod')) >= 0;
        if (isIOS) {
          if ((window as any).webkit.messageHandlers) {
            (window as any).webkit.messageHandlers.pdf.postMessage(`${[img]}`);
          }
        } else {
          this.isAttachmentUrls = true;
          this.showingUrls = [
            {
              url: img,
              objectKey: chat.attachmentUrls[index].objectKey,
            },
          ];
        }
      } else {
        // let img = chat.attachmentUrls[0].url;
        // const isImgExpired = this.isPresignedUrlExpired(
        //   chat.attachmentUrls[index].url,
        // );
        // if (isImgExpired) {
        //   const objectKey = chat.attachmentUrls[index].objectKey;
        //   const imgContent = await resourceModule.postResourceDownload({
        //     objectKey,
        //   });
        //   img = imgContent.preSignedUrl;
        // }
        this.notPdfImgSrc = img;
        this.isImgDialog = true;
      }
    },
    // async openChatImg(chat: ChatResponse) {
    //   let imgs = chat.attachmentUrls;
    //   const isImgExpired = this.isPresignedUrlExpired(chat.attachmentUrls[0]);
    //   if (isImgExpired) {
    //     this.imgLoading = true;
    //     const chatContent = await chatModule.fetchChatContent({
    //       chatId: chat.chatId,
    //       date: this.date.format('YYYY-MM-DD'),
    //     });
    //     imgs = chatContent.attachmentUrls;
    //     this.imgLoading = false;
    //   }
    //   const ua = navigator.userAgent;
    //   const isIOS =
    //     ua.indexOf('iPhone') >= 0 ||
    //     ua.indexOf('iPad') >= 0 ||
    //     Number(navigator.userAgent.indexOf('iPod')) >= 0;

    //   const pdfs = imgs.filter((img) => img.indexOf('.pdf?') >= 0)
    //   const jpgpngs = imgs.filter((img) => (img.indexOf('.jpg?') >= 0) || (img.indexOf('.jpeg?') >= 0) || (img.indexOf('.png?') >= 0))
      
    //   if (isIOS && pdfs.length > 0) {
    //     console.log((window as any).webkit.messageHandlers);
    //     if ((window as any).webkit.messageHandlers) {
    //       (window as any).webkit.messageHandlers.pdf.postMessage(`${pdfs}`);
    //     }
    //   } else {
    //     this.isAttachmentUrls = true;
    //     this.showingUrls = jpgpngs;
    //   }
    // },
    closeChatImg() {
      this.isAttachmentUrls = false;
      this.showingUrls = [];
    },
    createAbsence() {
      this.init();
      this.snackBarText = i18n.global.t('communication.confirmed');
      this.snackbar = true;
    },
    deleteAbsence() {
      this.init();
      this.snackBarText = i18n.global.t('communication.deleted');
      this.snackbar = true;
    },
    clickDeleteDialog(chat: ChatResponse) {
      this.actionDialog = false;
      this.deleteDialog = true;
      this.tempChat = chat;
    },
    openTranslateDialog(chat: ChatResponse) {
      this.translationChat = chat;
      this.isTranslationDialog = true;
    },
    getTranslatedChatsKey(): string {
      return `translatedChats_${this.childId}`;
    },
    loadTranslatedChats() {
      try {
        const raw = localStorage.getItem(this.getTranslatedChatsKey());
        this.translatedChats = raw ? JSON.parse(raw) : {};
      } catch {
        this.translatedChats = {};
      }
    },
    saveTranslatedChats() {
      try {
        localStorage.setItem(this.getTranslatedChatsKey(), JSON.stringify(this.translatedChats));
      } catch (error) {
        console.error('Translated chats save error:', error);
      }
    },
    onTranslated(chat: ChatResponse, translatedText: string) {
      this.translatedChats[chat.chatId] = translatedText;
      // 上限を超えたら古いメッセージ（chatIdが小さいもの）から削除する
      const MAX_TRANSLATED_CHATS = 50;
      const chatIds = Object.keys(this.translatedChats)
        .map(Number)
        .sort((a, b) => a - b);
      const overflow = chatIds.length - MAX_TRANSLATED_CHATS;
      for (let i = 0; i < overflow; i++) {
        delete this.translatedChats[chatIds[i]];
      }
      this.saveTranslatedChats();
    },
    returnTranslate(chatId: number) {
      delete this.translatedChats[chatId];
      this.saveTranslatedChats();
    },
    async deleteChat() {
      try {
        this.deleteLoading = true;
        await chatModule.deleteChat({
          childId: this.tempChat.child.childId,
          chatId: this.tempChat.chatId,
        });
        await chatModule.fetchChat({
          childId: this.childId,
          date: this.date.format('YYYY-MM-DD'),
        });
        this.deleteDialog = false;
        this.snackBarText = (this as any).$t('communication.deleted');
        this.snackbar = true;
      } catch {
      } finally {
        this.deleteLoading = false;
      }
    },

    async saveComment() {
      if (this.inputComment && this.inputComment.length > this.COMMENT_MAX_LENGTH) {
        this.snackBarText = (this as any).$t('comment.exceedsLimit');
        this.snackbar = true;
        return;
      }
      if (this.inputComment && this.child) {
        try {
          this.commentLoading = true;
          await chatModule.saveComment({
            childId: this.child.childId,
            date: this.date.format('YYYY-MM-DD'),
            comment: this.inputComment,
          });
          chatModule.fetchChat({
            childId: this.childId,
            date: this.date.format('YYYY-MM-DD'),
          });
          this.snackBarText = (this as any).$t('messages.saveSuccess');
          this.snackbar = true;
        } catch {
        } finally {
          this.commentLoading = false;
        }
      }
    },
    async dblClick(chat: ChatResponse) {
      if (chat.chatId) {
        try {
          this.btnLoadingChat = true;
          await chatModule.confirmChat({
            chatId: chat.chatId,
            childId: this.childId,
          });
          chatModule.fetchChat({
            childId: this.childId,
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoadingChat = false;
        }
      }
    },
    addDay() {
      this.date = this.date.add(1, 'd');
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      this.subtractflg = true;
    },
    openDateDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dateDialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      this.dateDialogFlg = false;
    },
    saveDraft: async function() {
      if (this.inputText) {
        try {
          this.btnDraftLoading = true;
          if (this.draftChatId) {
            const response = await chatModule.saveChatDraft({
              childId: this.childId,
              chatId: Number(this.draftChatId),
              body: this.inputText,
            });
            if (this.child) {
              this.$router.push(`/communication/chat/${this.child.childId}`);
            }
          } else {
            const response = await chatModule.saveChatDraft({
              childId: this.childId,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
            });
          }
          this.snackBarText = (this as any).$t('communication.savedToDraft');
          this.snackbar = true;
        } catch {
        } finally {
          this.inputText = '';
          this.btnDraftLoading = false;
        }
      }
    },
    saveSendReady: async function() {
      if (this.inputText) {
        try {
          this.btnReadyLoading = true;
          if (this.readyChatId) {
            const response = await chatModule.saveChatReady({
              childId: this.childId,
              chatId: Number(this.readyChatId),
              body: this.inputText,
            });
            if (this.child) {
              this.$router.push(`/communication/chat/${this.child.childId}`);
            }
          } else {
            const response = await chatModule.saveChatReady({
              childId: this.childId,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
            });
          }
          this.snackBarText = (this as any).$t('communication.savedToReadySend');
          this.snackbar = true;
        } catch {
        } finally {
          this.inputText = '';
          this.btnReadyLoading = false;
        }
      }
    },
    sendMessage: async function() {
      if (this.inputText) {
        try {
          this.btnSendLoading = true;
          if (this.draftChatId) {
            await chatModule.saveChatDraft({
              childId: this.childId,
              chatId: Number(this.draftChatId),
              body: this.inputText,
            });
            await chatModule.sendChat({
              childId: this.childId,
              chatId: Number(this.draftChatId),
            });
            if (this.child) {
              this.$router.push(`/communication/chat/${this.child.childId}`);
            }
          } else if (this.readyChatId) {
            await chatModule.saveChatReady({
              childId: this.childId,
              chatId: Number(this.readyChatId),
              body: this.inputText,
            });
            const chatIds = [this.readyChatId];
            await chatModule.sendChatReady(chatIds);
            await chatModule.fetchChat({
              childId: this.childId,
              date: this.date.format('YYYY-MM-DD'),
            });
            if (this.child) {
              this.$router.push(`/communication/chat/${this.child.childId}`);
            }
          } else {
            const response = await chatModule.sendChat({
              childId: this.childId,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
            });
          }
          this.chatsScrollToBottom();
        } catch {
        } finally {
          this.btnSendLoading = false;
        }
      }
      this.inputText = '';
    },
    toClassDiary() {
      const classId = this.child?.nurseryClasses[0].classId;
      if (classId) {
        this.$router.push(`/record/class/${classId}`);
      }
    },
    toChildDiary() {
      const childId = this.child?.childId;
      let classId = this.child?.nurseryClasses[0].classId;
      const date = this.date.format('YYYY-MM-DD');
      this.child?.nurseryClasses.forEach(function(arrayClass){
        if(arrayClass['year'] === getBusinessYearForJapanTz(getDayjsInstanceTz(date))){
          classId = arrayClass.classId;
        }
      })
      if (childId && classId) {
        this.$router.push(`/record/class/${classId}/child/${childId}`);
      }
    },
    init: async function() {
      this.fetchLoading = true;
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        this.nurseryId = nurseryId;
        const childId = this.$route.params.childId;
        this.childId = parseInt(childId as string, 10);
        this.loadTranslatedChats();
        let bussinesClass = this.child?.nurseryClasses[0].classId;

        if (childId) {
          await chatModule.fetchChat({
            childId: this.childId,
            date: this.date.format('YYYY-MM-DD'),
          });
          await Promise.all([childrenModule.getChild(this.childId)]);
          if (this.child) {
            const date = this.date.format('YYYY-MM-DD');
            this.child.nurseryClasses.forEach(function(arrayClass){
              if(arrayClass['year'] === getBusinessYearForJapanTz(getDayjsInstanceTz(date))){
                bussinesClass = arrayClass.classId;
              }
            })
            childrenModule.getChildren({
              nurseryId,
              classId: bussinesClass,
            });
          }
        }
        if (chatModule.chats && chatModule.chats.comment) {
          this.inputComment = chatModule.chats.comment.comment;
        } else {
          this.inputComment = '';
        }
        this.classId = bussinesClass ?? 0;
        Promise.all([
          nurseryModule.getNurseryClassDetail({
            nurseryId,
            classId: this.classId,
          }),
          childrenModule.getChild(this.childId),
        ]);
        this.$nextTick(() => {
          this.fetchLoading = false;
        });
        this.chatsScrollToBottom();
      }
    },
    formatTime(createdAt: string) {
      // Fix bug no 27
      return formatChatTime(createdAt, this.date.format('YYYY-MM-DD'), { multiline: true });
    },
    chatsScrollToBottom() {
      const selectedElement: Element = document.getElementsByClassName('chat-area')[0];
      if (selectedElement) {
        selectedElement.scrollTop = selectedElement.scrollHeight;
      }
    },
    clickToParentsRecord() {
      if (this.child) {
        const classId = this.child.nurseryClasses[0].classId;
        this.$router.push({
          path: `/record/parents-record/class/${classId}/child/${this.child.childId}`,
          query: { date: `${this.date.toISOString()}` },
        });
      }
    },
  },
  async created() {
    const date = this.$route.query.date as string;
    if (date) {
      const temp = dayjs(date);
      this.date = temp;
    }
    await this.init();
    const localText = LocalDataService.getChatText();
    const tempChildId = LocalDataService.getChatChildId();
    if (localText && tempChildId) {
      const localChildId = parseInt(tempChildId, 10);
      if (this.childId && this.childId === localChildId) {
        this.inputText = localText;
      }
    }
  },
  async mounted() {
    const user = LocalDataService.getUser();
    if (user) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;

      // 下書きからの遷移の場合(個別)
      this.draftChatId = this.$route.query.draftChatId as string;
      if (this.draftChatId) {
        Promise.all([chatModule.fetchChatDraft({ nurseryId })]);
        const text = this.$route.query.text as string;
        if (text) {
          this.inputText = text;
        }
      }
      // 送信準備からの遷移の場合(個別)
      this.readyChatId = this.$route.query.readyChatId as string;
      if (this.readyChatId) {
        Promise.all([chatModule.fetchChatReady({ nurseryId })]);
        const text = this.$route.query.text as string;
        if (text) {
          this.inputText = text;
        }
      }
    }
  },
  unmounted() {
    childrenModule.refreshChild();
    if (this.inputText) {
      LocalDataService.setChatText(this.inputText);
      LocalDataService.setChatChildId(this.childId.toString(10));
    } else {
      LocalDataService.removeChatText();
    }

    chatModule.resetChat();

    meModule.setTabIndex('message');
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;
@use '@/sass/ress.scss' as *;

.reative {
  position: relative;
}

.header-bar {
  position: fixed;
  width: 100%;
}

.header-wrapper {
  position: fixed;
  width: 100%;
  top: 64px;
  z-index: 2;
}

.chat-area {
  margin-top: 44px;
  padding-top: 60px;
  padding-bottom: 70px;
  overflow: scroll;
  height: 75vh;
}

.chat-wrapper {
  max-width: 80%;
  background-color: #f5f6f6;
  border-radius: 5px;
  position: relative;
}

.delete-chat {
  background: white;
  color: red;
  padding: 3px;
  border-radius: 4px;
  animation: fadeIn 0.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.info-wrapper {
  max-width: 80%;
  border-radius: 5px;
  border: 2px solid rgb(var(--v-theme-primary));
  background-color: #fff;
  color: rgb(var(--v-theme-primary));
}

.staff-chat {
  background-color: rgb(var(--v-theme-primary));
  color: #fff;
  align-self: flex-end;
  white-space: pre-line;
  overflow: hidden;
  height: auto;
  .autolinked ::v-deep .highlights {
    color: #fff;
  }
}

.input-wrapper {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
  z-index: 3;

  .input-chat-area {
    max-height: 500px;
    overflow-y: scroll;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.comment-area {
  max-height: 150px;
  overflow-y: scroll;
}

.action-area {
  position: fixed;
  bottom: 19%;
  right: 5px;
  animation: fadeIn 0.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  z-index: 10 !important;
}
.group-chat {
  background: #fff;
  font-weight: bold;
  border: solid #176ed3;
  color: #176ed3;
}

.comment-dialog {
  z-index: 4 !important;
}

/* [START]Fix font size text button in quick row */
.comment-dialog-quick-row--outlined {
  width: 100%;
  box-sizing: border-box;
  padding-inline: 3px;
  gap: 5px;
  flex-wrap: nowrap;
}

/* Vuetify VBtn: .v-btn__content uses white-space: nowrap; .v-btn has flex-shrink: 0 — causes overflow when text is long */
.comment-dialog-quick-row--outlined .comment-dialog-quick-btn {
  flex: 1 1 0;
  min-width: 0 !important;
  flex-shrink: 1 !important;
  width: auto !important;
  max-width: 100%;
}

.comment-dialog-quick-row--flat {
  width: 100%;
  box-sizing: border-box;
  padding-inline: 10px;
  gap: 15px;
  flex-wrap: nowrap;
}

.comment-dialog-quick-row--flat .comment-dialog-quick-btn {
  flex: 1 1 0;
  min-width: 0 !important;
  flex-shrink: 1 !important;
  width: auto !important;
  max-width: 100%;
}

.comment-dialog-quick-btn {
  height: auto !important;
  min-height: 44px;
  text-transform: none !important;
  letter-spacing: normal !important;
  text-indent: 0 !important;
  padding: 5px 0 5px 5px !important;

  :deep(.v-btn__content) {
    width: 100%;
    min-width: 0 !important;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline: 5px;
    white-space: normal !important;
  }
}

/* Group label + icon, center the whole block in the button; icon close to the text, vertically centered when text is multi-line */
.comment-dialog-quick-btn__inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.comment-dialog-quick-btn__label {
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 20px);
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  white-space: normal !important;
  overflow-wrap: break-word;
  word-break: normal;
}

.comment-dialog-quick-btn__chevron {
  flex-shrink: 0;
}

@media (max-width: 339px) {
  .comment-dialog-quick-btn__label {
    font-size: calc(0.875rem - 2px);
    max-width: calc(100% - 22px);
  }

  .comment-dialog-quick-btn__chevron {
    font-size: 18px !important;
  }
}

/*[START] Japanese only */
.comment-dialog-quick-btn--ja {
  :deep(.v-btn__content) {
    white-space: nowrap !important;
  }
}

.comment-dialog-quick-btn--ja .comment-dialog-quick-btn__label {
  white-space: nowrap !important;
  word-break: keep-all;
  letter-spacing: 0.15rem;
  line-height: 1;
}


@media (max-width: 399px) {
  .comment-dialog-quick-btn--ja {
    min-height: 36px;
    :deep(.v-btn__content) {
      padding-inline: 0!important;
    }
  }
  .comment-dialog-quick-btn--ja .comment-dialog-quick-btn__label {
    font-size: calc(0.875rem - 3px);
    line-height: 1;
  }

  .comment-dialog-quick-btn--ja .comment-dialog-quick-btn__chevron {
    font-size: 17px !important;
  }
}
/* [END] Japanese only */
/* [END]Fix font size text button in quick row */


.absence-dialog {
  z-index: 10 !important;
}

.pdf_wrapper {
  height: 100%;
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }
}
.pdf_header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }
}
.pdf {
  height: 100%;
  width: 100%;
  padding-top: 56px;
  overflow: scroll;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top) + 56px);
  }
  img {
    display: block;
    height: 200%;
    width: 200%;
  }
}
.no-tap {
  -webkit-touch-callout: none;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}
.tap-on {
  -webkit-touch-callout: default;
  user-select: auto;
  -moz-user-select: default; /* Firefox */
  -ms-user-select: default; /* Internet Explorer */
  -khtml-user-select: default; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: default; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: default; /* Disable Android and iOS callouts*/
}
</style>
